import methods from './methods'
import keys from './keys'

export default {
  methods,
  keys,
}
